import Image from "next/image";
import Link from "next/link";

interface TBanners {
  banners: {
    url: string;
    img: {
      sourceUrl: string;
      altText: string;
    };
  }[];
}

export const Promotion = ({ banners }: TBanners) => (
  <div className="relative px-1 py-4 sm:px-2">
    <div className="mx-auto flex max-w-screen-xl flex-col gap-10 py-4 md:gap-0 lg:flex-row">
      {banners.map((item) => (
        <div
          className="relative w-full overflow-hidden lg:m-4 lg:w-1/2"
          key={item.url}
        >
          {item.url && (
            <Link aria-label={item.img?.altText || "Promotion"} href={item.url}>
              <Image
                alt={item.img?.altText || "Promotion"}
                className="w-full transition-all duration-500 ease-in-out hover:scale-105"
                height={300}
                src={item.img?.sourceUrl}
                width={600}
              />
            </Link>
          )}
        </div>
      ))}
    </div>
  </div>
);
